import React from "react";
import { Box, Button, useTheme, useMediaQuery } from "@mui/material";
import { EyeOff, CirclePlay } from "lucide-react";
import { mmkBatchActionsBarStyles } from "./styles";

interface MmkBatchActionsProps {
  selectedCount: number;
  onHide: () => void;
  onPractice: () => void;
  onClear: () => void;
}

export const MmkBatchActions: React.FC<MmkBatchActionsProps> = ({
  selectedCount,
  onHide,
  onPractice,
  onClear,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const iconSize = isSmallScreen ? 14 : 16;
  const fontSize = isSmallScreen ? "12px" : "14px";

  return (
    <Box sx={mmkBatchActionsBarStyles}>
      <Button
        size="small"
        variant="outlined"
        startIcon={<EyeOff size={iconSize} />}
        onClick={onHide}
        sx={{ fontSize }}
      >
        Hide ({selectedCount})
      </Button>
      <Button
        size="small"
        variant="contained"
        startIcon={<CirclePlay size={iconSize} />}
        onClick={onPractice}
        sx={{ fontSize }}
      >
        Practice ({selectedCount})
      </Button>
      <Button size="small" onClick={onClear} sx={{ fontSize }}>
        Clear
      </Button>
    </Box>
  );
};
